import { render } from "./DocCard.vue?vue&type=template&id=3db8cb54&scoped=true"
import script from "./DocCard.vue?vue&type=script&lang=js"
export * from "./DocCard.vue?vue&type=script&lang=js"

import "./DocCard.vue?vue&type=style&index=0&id=3db8cb54&lang=less&scoped=true"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3db8cb54"]])

export default __exports__